import KunLoading35 from './src/index'

KunLoading35.install = function (Vue) {
	Vue.component(KunLoading35.name, KunLoading35);
}

export default KunLoading35;
